import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axiosSetup";

import "../pages/LoginPage.css";       
import "./ForgotPassword.css";

import LoginImage from "../assets/LoginPageImage.svg";
import Logo from "../assets/LoginVocovoLogo.svg";
import HumanIcon from "../assets/OrangeHumanIcon.svg";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [requiresRoleSelection, setRequiresRoleSelection] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");

  const getRoleOptions = (roles = []) => {
    if (!Array.isArray(roles) || roles.length === 0) {
      return ["user", "customer"];
    }

    return roles.map((role) => String(role || "").trim().toLowerCase()).filter(Boolean);
  };

  const formatRoleLabel = (role) => {
    const normalizedRole = String(role || "").trim().toLowerCase();
    if (!normalizedRole) return "";
    return normalizedRole.charAt(0).toUpperCase() + normalizedRole.slice(1);
  };

  const validate = () => {
    if (!email.trim()) return "Email is required.";
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(email.trim())) return "Enter a valid email.";
    if (requiresRoleSelection && !selectedRole) {
      return "Please select a role to continue.";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const v = validate();
    if (v) {
      setError(v);
      return;
    }

    setLoading(true);

    try {
      const response = await axios.get("/auth/generate-reset-link", {
        params: {
          email: email.trim(),
          ...(requiresRoleSelection && selectedRole ? { role: selectedRole } : {}),
        },
      });

      if (response.status === 200 && response.data?.requiresRoleSelection) {
        const roles = getRoleOptions(response.data.roles);
        setRequiresRoleSelection(true);
        setAvailableRoles(roles);

        if (!roles.includes(selectedRole)) {
          setSelectedRole("");
        }

        setLoading(false);
        return;
      }

      setRequiresRoleSelection(false);
      setAvailableRoles([]);
      setSelectedRole("");

      setSuccess(
        response.data?.message ||
          "If this email exists, a reset link has been sent."
      );

      setTimeout(() => navigate("/login", { replace: true }), 1800);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Unable to send reset link. Try again later."
      );
    }

    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <img src={LoginImage} alt="Forgot Password visual" className="login-visual" />
      </div>

      <div className="login-card">
        <div className="logo-box-wrapper">
          <div className="logo-box">
            <img src={Logo} className="login-logo" alt="logo" />
          </div>
        </div>

        <h2 className="login-title">Forgot Password</h2>
        <p className="fp-description">
          Enter your email and we'll send you a password reset link.
        </p>

        <div className="input-group">
          <img src={HumanIcon} alt="" className="input-icon" />
          <input
            type="email"
            placeholder="Enter email"
            className="login-input"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
              setSuccess("");
              setRequiresRoleSelection(false);
              setAvailableRoles([]);
              setSelectedRole("");
            }}
          />
        </div>

        {requiresRoleSelection && (
          <div className="input-group">
            <img src={HumanIcon} alt="" className="input-icon" />
            <select
              className="login-input login-select"
              value={selectedRole}
              onChange={(e) => {
                setSelectedRole(e.target.value);
                setError("");
              }}
              disabled={loading}
            >
              <option value="">Select role</option>
              {availableRoles.map((role) => (
                <option key={role} value={role}>
                  {formatRoleLabel(role)}
                </option>
              ))}
            </select>
          </div>
        )}

        <button className="login-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? "Sending..." : "Send Reset Password Link"}
        </button>
        {error && <p className="error-text">{error}</p>}
        {success && <p className="success-text">{success}</p>}

        <p className="forgot-password back-login" onClick={() => navigate("/login")}>
           Back to Login
        </p>
        
      </div>
    </div>
  );
};

export default ForgotPassword;
